<template>
    <div class="divider" />
    <div class="exchanging-colors-keeper" />
    <div class="exchanging-colors-keeper" />
    <div class="exchanging-colors-keeper" />
</template>

<style scoped lang="scss">
.exchanging-colors-keeper,
.divider {
    grid-column: 1 / -1; // spans from column 1 to the end
}

.divider {
    height: 1px;
    padding: 0 12px;

    &:after {
        content: '';
        display: block;
        width: 100%;
        border-top: 1px solid theme('colors.pink-200');
    }
}
</style>
